import { render } from "./ReferralItem.vue?vue&type=template&id=3c9ec21f"
import script from "./ReferralItem.vue?vue&type=script&lang=js"
export * from "./ReferralItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__